import styled from 'styled-components'
import tw from 'twin.macro'

export const Root = styled.div``

export const Table = styled.table`
  ${tw`w-full mb-6`};

  tr + tr td {
    ${tw`pt-2`};
  }

  td:last-child {
    ${tw`text-right`};
  }

  tr:last-child td {
    ${tw`relative pt-6`};
  }

  tr:last-child td::before {
    content: '';
    ${tw`absolute top-3 left-0 w-full h-px`};
    background-color: var(--color-grey);
  }
`
